"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.display_event = void 0;
var utils_1 = require("../../utils");
var qs = require('qs');
exports.display_event = function (axios) {
    return {
        getEvents: function (getEventsRequest) {
            return axios.get('/events', {
                params: getEventsRequest.params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, { arrayFormat: 'repeat' });
                }
            });
        },
        /** @deprecated getEventsEventNo 를 사용하세요. */
        getEventsEnentNo: function (request) {
            var url = utils_1.paramPathchange('/events/{eventNo}', request);
            return axios.get(url);
        },
        getEventsEventNo: function (request) {
            var url = utils_1.paramPathchange('/events/{eventNo}', request);
            return axios.get(url);
        },
        getEventsSummary: function (getEventsSummary) {
            return axios.get('/events/summary', getEventsSummary);
        },
        postEvents: function (postEventsRequest) {
            return axios.post('/events', postEventsRequest.data);
        },
        deleteEvents: function (deleteEventsRequest) {
            var query = qs.stringify(deleteEventsRequest.params, { arrayFormat: 'comma' });
            return axios.delete("/events?" + query);
        },
        getEventsEventNoSectionsProducts: function (request) {
            var url = utils_1.paramPathchange('/events/{eventNo}/sections/products', request);
            return axios.get(url);
        },
        putEventsEventNo: function (putEventsEventNoRequest) {
            var url = utils_1.paramPathchange('/events/{eventNo}', putEventsEventNoRequest);
            return axios.put(url, putEventsEventNoRequest.data);
        },
        /** @description 기획전 URL 중복체크 */
        getEventsDuplicate: function (getEventsDuplicateRequest) {
            return axios.get('/events/duplicate', getEventsDuplicateRequest);
        },
        /** @description 기획전 ID 중복체크 */
        getEventsDuplicateId: function (getEventsDuplicateIdRequest) {
            return axios.get('/events/duplicate/id', getEventsDuplicateIdRequest);
        },
        getEventsExcel: function (getEventsExcelRequest) {
            return axios.get('/events/excel', {
                params: getEventsExcelRequest.params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, { arrayFormat: 'repeat' });
                }
            });
        }
    };
};
